import { MenuItem, Stack, TextField } from '@mui/material'

const OTHER = '__other__'

/** The accessible name, which is also what the user reads. */
function fieldLabel(question) {
  return question.required === false ? `${question.question} (optional)` : question.question
}

/** One question. `select` with `allow_other` reveals a free-text box below it. */
export default function ClarificationField({ question, value, otherValue, disabled, onChange }) {
  const type = question.input?.type ?? 'text'
  const isSelect = type === 'select' && question.options?.length > 0
  const showOther = isSelect && question.allow_other && value === OTHER
  return (
    <Stack sx={{ gap: 0.5 }}>
      <TextField
        size="small"
        select={isSelect}
        label={fieldLabel(question)}
        // `date` and `number` get the native control; `email` deliberately does
        // not, because the browser's own validity bubble would fire before the
        // server message this card is designed to show.
        type={isSelect || type === 'email' ? undefined : type}
        value={value ?? ''}
        disabled={disabled}
        onChange={(event) => onChange(question.id, event.target.value, otherValue)}
      >
        {isSelect
          ? [
              ...question.options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              )),
              ...(question.allow_other ? [<MenuItem key={OTHER} value={OTHER}>Other…</MenuItem>] : []),
            ]
          : null}
      </TextField>
      {showOther ? (
        <TextField
          size="small"
          label={`${question.question} — other`}
          value={otherValue ?? ''}
          disabled={disabled}
          onChange={(event) => onChange(question.id, OTHER, event.target.value)}
        />
      ) : null}
    </Stack>
  )
}

export { OTHER }
